import { useEffect, useState } from "react";

// Mirrors the former server-rendered login page. The OAuth-provider redirects
// unauthenticated MCP clients here with the original authorize query attached,
// so we forward window.location.search verbatim as the callbackURL to keep its
// signature intact; a plain visit just lands on /settings.
export function LoginPage() {
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    document.title = "Sign in · ultracoach";
    const params = new URLSearchParams(window.location.search);
    if (params.get("error")) {
      setError(
        params.get("error") === "denied"
          ? "That account is not on the allowlist."
          : "Sign-in failed. Please try again.",
      );
    }
  }, []);

  async function signIn() {
    setError("");
    setBusy(true);
    const qs = window.location.search;
    const params = new URLSearchParams(qs);
    const callbackURL = params.has("client_id")
      ? "/api/auth/oauth2/authorize" + qs
      : "/settings";
    try {
      const res = await fetch("/api/auth/sign-in/social", {
        method: "POST",
        credentials: "include",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          provider: "google",
          callbackURL,
          errorCallbackURL: "/login?error=denied",
        }),
      });
      const d = (await res.json().catch(() => ({}))) as {
        url?: string;
        message?: string;
      };
      if (d?.url) {
        window.location.href = d.url;
        return;
      }
      setError(d.message || "Could not start Google sign-in.");
      setBusy(false);
    } catch {
      setError("Network error");
      setBusy(false);
    }
  }

  return (
    <>
      <div className="mark">
        <i />
        <i />
        <i />
        <i />
      </div>
      <h1>
        ultra<span className="brand">coach</span>
      </h1>
      <p className="sub">Sign in with Google to continue.</p>
      <button type="button" disabled={busy} onClick={signIn}>
        Continue with Google
      </button>
      <div className="err">{error}</div>
    </>
  );
}
